import { render, staticRenderFns } from "./distinguish.vue?vue&type=template&id=7f4b84a9&scoped=true"
import script from "./distinguish.vue?vue&type=script&lang=js"
export * from "./distinguish.vue?vue&type=script&lang=js"
import style0 from "./distinguish.vue?vue&type=style&index=0&id=7f4b84a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b84a9",
  null
  
)

export default component.exports